import { BrandMark } from '../../components/BrandMark'
import type { ShareApiError } from '../../lib/shareApi'
import './ProfileScreen.css'

/**
 * The centered end-state notice shown when a link can't be opened or read: a
 * lapsed/revoked link reads as "no longer active" (calm, not alarming); anything
 * else is a generic retry. Shared by the open flow (SharePage) and the profile
 * read (ProfileScreen) so the copy lives in exactly one place. Link-only framing:
 * a fresh link, no access-code mention.
 */
export function ProfileNotice({ reason }: { reason: ShareApiError['reason'] }) {
  const inactive = reason === 'expired' || reason === 'not_found'
  return (
    <main className='profile profile--center'>
      <div className='profile__notice'>
        <BrandMark />
        <h1 className='profile__notice-title'>
          {inactive ? 'This link is no longer active' : 'Something went wrong'}
        </h1>
        <p className='profile__notice-sub'>
          {inactive
            ? 'Ask for a fresh link to see the latest profile.'
            : 'Please refresh the page and try again.'}
        </p>
      </div>
    </main>
  )
}
